import React from 'react';
import { GameStats } from './GameStats';
import { PedometerWidget } from './PedometerWidget';
import { MiningProgress } from './MiningProgress';
import { ClickButton } from './ClickButton';
import { DEMO_CONFIG } from '../../config/contract';

interface GameContainerProps {
  gameState: any;
  account: string | null;
  onMiningClick: () => void;
}

export function GameContainer({ gameState, account, onMiningClick }: GameContainerProps) {
  return (
    <>
      <GameStats
        clicks={gameState.clicks}
        coinsPerClick={gameState.coinsPerClick || 1}
        balance={gameState.balance}
        autoClickerCount={gameState.autoClickerCount}
        walletAddress={account}
      />

      <PedometerWidget walletAddress={account} />

      <MiningProgress
        miningClicks={gameState.miningClicks}
        pendingWei={gameState.pendingWei}
        cycleSize={DEMO_CONFIG.clicksPerCycle}
      />

      <ClickButton onClick={onMiningClick} />
    </>
  );
}